// extracted by mini-css-extract-plugin
export var arrowIcon = "arrowIcon-module--arrowIcon--a9fcc";
export var noScroll = "arrowIcon-module--no-scroll--f32a0";
export var rotateDown = "arrowIcon-module--rotateDown--2167f";
export var rotateLeft = "arrowIcon-module--rotateLeft--c9a6f";
export var rotateRight = "arrowIcon-module--rotateRight--5b9aa";
export var rotateUp = "arrowIcon-module--rotateUp--5f037";